import React from 'react';
import { CreateFlowItemMenu } from './containers/CreateFlowItemMenu';
import { CreateCustomComponentsMenu } from './containers/CreateCustomComponentMenu';

export const CreateFlowItem = () => {
  return (
    <>
      <CreateCustomComponentsMenu />
      <CreateFlowItemMenu />
    </>
  )
}
